export const apiEndpoints = {
  base: '/api/v1',
  health: '/health',
} as const

export const appRoutes = {
  home: '/',
  cars: '/cars',
  carDetails: (slug: string = ':slug') => `/cars/${slug}`,
  carModelShowcase: (modelSlug: string = ':modelSlug') => `/cars/models/${modelSlug}`,
  carBrandShowcase: (brandSlug: string = ':brandSlug') => `/cars/brands/${brandSlug}`,
  parts: '/parts',
  partDetails: (slug: string = ':slug') => `/parts/${slug}`,
  dashboard: {
    root: '/dashboard',
    messages: '/dashboard/messages',
  },
  auth: {
    login: '/login',
    register: '/register',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    verifyEmail: '/verify-email',
    verificationPending: '/verify-email/pending',
    oauthFailure: '/oauth-failure',
  },
  customer: {
    becomeSeller: '/customer/become-seller',
    becomeDealer: '/customer/become-dealer',
    approvalHistory: '/customer/approval-history',
    messages: '/dashboard/messages',
    orders: '/dashboard/orders',
  },
  seller: {
    root: '/seller',
    orders: '/seller/orders',
    billing: '/seller/billing',
    messages: '/seller/messages',
  },
  dealer: {
    root: '/dealer',
    orders: '/dealer/orders',
    billing: '/dealer/billing',
    messages: '/dealer/messages',
  },
  admin: {
    root: '/admin',
    dashboard: '/admin/dashboard',
    cars: {
      overview: '/admin/cars',
      brands: '/admin/cars/brands',
      models: '/admin/cars/models',
      generations: '/admin/cars/generations',
      variants: '/admin/cars/variants',
      features: '/admin/cars/features',
      listings: '/admin/cars/listings',
      modelRequests: '/admin/cars/model-requests',
    },
    users: '/admin/users',
    sellerRequests: '/admin/seller-requests',
    dealerRequests: '/admin/dealer-requests',
    subscriptions: '/admin/subscriptions',
    billing: '/admin/billing',
    plansManagement: '/admin/plans-management',
    formBuilder: '/admin/form-builder',
    workflowSettings: '/admin/workflow-settings',
    auditLogs: '/admin/audit-logs',
    payments: '/admin/payments',
    parts: '/admin/parts',
    orders: '/admin/orders',
    settings: '/admin/settings',
  },
  notFound: '/404',
} as const

